import * as Styled from './HeaderTitleWithRightButton.styled';

type HeaderTitleWithRightButtonProps = {
    title: string;
    buttonText: string;
    variant?: 'text' | 'outlined' | 'contained';
    onButtonClick: () => void;
};

export const HeaderTitleWithRightButton = ({ title, buttonText, variant = 'text', onButtonClick }: HeaderTitleWithRightButtonProps) => {
    return (
        <>
            <Styled.HeaderContainer>
                <Styled.HeaderText>
                    {title}
                </Styled.HeaderText>
                <Styled.ButtonLink component="button" onClick={onButtonClick} variant={variant} bold>
                    {buttonText}
                </Styled.ButtonLink>
            </Styled.HeaderContainer>
        </>
    );
};